import React from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {DemandeTransfertListPage} from './DemandeTransfertListPage'

const DemandeTransfertWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[
        {title: 'Demandes de transfert', path: '#', isSeparator: false, isActive: true}
      ]}>Liste</PageTitle>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <DemandeTransfertListPage/>
            </>
          }
        />

        <Route index element={<Navigate to='/demande-transfert/liste'/>}/>
      </Routes>
    </>
  )
}

export {DemandeTransfertWrapper}
